/**
 @since: 2020-05-07
 @author: tams_dev1
 */
import resultFactory from '~/utils/resultFactory'
import compareObject from '~/utils/compare'

const smtpData = {
  smtp_alert_msg: '', // (string) SMTP 알림 메시지,
  smtp_excpt_mail_list_id: null, // (integer)(not null) 예외 메일 ID
  smtp_spam: {
    smtp_spam_chk_use: 0, // (integer)(not null)(Define=0,1) 사용 여부 사용안함: 0, 사용: 1,
    smtp_spam_chk_direct: 3, // (integer)(not null)(Define=1,2,3) 방향 내부:1, 외부: 2, 양방향: 3,
    smtp_spam_chk_action: 1 // (integer)(not null)(Define=1,2,3) 탐지: 1, 차단: 2, 알림: 3
  },
  smtp_ban_word: {
    smtp_ban_word_chk_use: 0, // (integer)(not null)(Define=0,1) 사용 여부 사용안함: 0, 사용: 1,
    smtp_ban_word_chk_direct: 3, // (integer)(not null)(Define=1,2,3) 방향 내부:1, 외부: 2, 양방향: 3,
    smtp_ban_word_chk_action: 1, // (integer)(not null)(Define=1,2,3) 탐지: 1, 차단: 2, 알림: 3,
    smtp_ban_word_list_id: null // (integer) 금지명령어 ID
  },
  smtp_block_mail: {
    smtp_block_mail_chk_use: 0, // (integer)(not null)(Define=1,2) 사용 여부 사용안함: 0, 사용: 1,
    smtp_block_mail_chk_direct: 3, // (integer)(not null)(Define=1,2,3) 방향 내부:1, 외부: 2, 양방향: 3,
    smtp_block_mail_chk_action: 1, // (integer)(not null)(Define=1,2,3) 탐지: 1, 차단: 2, 알림: 3,
    smtp_block_mail_list_id: null // (integer)(not null) 차단 메일 ID
  },
  smtp_blank_title: {
    smtp_blank_title_chk_use: 0, // (integer)(not null)(Define=1,2) 빈 제목 검사 사용 여부 사용안함: 0, 사용: 1,
    smtp_blank_title_chk_direct: 3, // (integer)(not null)(Define=1,2,3) 방향 내부:1, 외부: 2, 양방향: 3,
    smtp_blank_title_chk_action: 1 // (integer)(not null)(Define=1,2,3) 탐지: 1, 차단: 2, 알림: 3
  },
  smtp_sndr_addr: {
    smtp_sndr_addr_chk_use: 0, // (integer) 송신자 주소 유효성 검사 사용 여부 사용안함: 0, 사용: 1,
    smtp_sndr_addr_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    smtp_sndr_addr_chk_action: 1 // (integer) 탐지: 1, 차단: 2, 알림: 3
  },
  smtp_mail_size: {
    smtp_mail_size_chk_use: 0, // (integer) 메일 크기 제한 사용 여부 사용안함: 0, 사용: 1,
    smtp_mail_size_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    smtp_mail_size_chk_action: 1, // (integer) 탐지: 1, 차단: 2, 알림: 3,
    smtp_mail_size_chk_size: 10240 // (integer) KB
  },
  smtp_mail_relay: {
    smtp_mail_relay_chk_use: 0, // (integer) 메일 릴레이 검사 사용 여부 사용안함: 0, 사용: 1,
    smtp_mail_relay_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    smtp_mail_relay_chk_action: 1, // (integer) 탐지: 1, 차단: 2, 알림: 3,
    smtp_mail_relay_list_id: null // (integer) 메일 릴레이 프로파일 ID
  },
  smtp_rbl: {
    smtp_rbl_chk_use: 0, // (integer)(not null)(Define=0,1) RBL 검사 사용 여부 사용안함: 0, 사용: 1,
    smtp_rbl_chk_direct: 3, // (integer)(not null)(Define=1,2,3) 방향 내부:1, 외부: 2, 양방향: 3,
    smtp_rbl_chk_action: 1 // (integer)(not null)(Define=1,2,3) 탐지: 1, 차단: 2, 알림: 3
  },
  smtp_ban_cmd: {
    smtp_ban_cmd_chk_use: 0, // (integer) SMTP 금지 명령어 사용 여부 사용안함: 0, 사용: 1,
    smtp_ban_cmd_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    smtp_ban_cmd_chk_action: 1, // (integer) 탐지: 1, 차단: 2, 알림: 3,
    smtp_ban_cmd_list_id: null // (integer) SMTP 금지 명령어 ID
  },
  smtp_rcvr_cnt: {
    smtp_rcvr_cnt_chk_use: 0, // (integer) 수신자 수 검사 사용 여부 사용안함: 0, 사용: 1,
    smtp_rcvr_cnt_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    smtp_rcvr_cnt_chk_action: 1, // (integer) 탐지: 1, 차단: 2, 알림: 3,
    smtp_rcvr_cnt_chk_size: 100 // (integer)(range=1-1000) 명
  },
  smtp_sess: {
    smtp_sess_chk_use: 0, // (integer) 세션 수 제한 사용 여부 사용안함: 0, 사용: 1,
    smtp_sess_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    smtp_sess_chk_action: 1, // (integer) 탐지: 1, 차단: 2, 알림: 3,
    smtp_sess_chk_size: 100 // (integer) 개
  },
  smtp_bomb_attack: {
    smtp_bomb_attack_chk_use: 0, // (integer)(not null)(Define=0,1) 사용 여부 사용안함: 0, 사용: 1,
    smtp_bomb_attack_chk_direct: 3, // (integer)(not null)(Define=1,2,3) 방향 내부:1, 외부: 2, 양방향: 3,
    smtp_bomb_attack_chk_action: 1, // (integer)(not null)(Define=1,2,3) 탐지: 1, 차단: 2, 알림: 3,
    smtp_bomb_attack_chk_value: {
      smtp_bomb_attack_chk_size: 10, // (integer)(range=1-100) 메일 폭탄 공격 검사 개,
      smtp_bomb_attack_chk_intval: 5 // (integer)(range=1-60) 메일 폭탄 공격 검사 초
    }
  },
  smtp_mail_cntnt_save: {
    smtp_mail_cntnt_save_use: 0, // (integer) 메일 본문 저장 사용 여부 사용안함: 0, 사용: 1,
    smtp_mail_cntnt_save_direct: 3 // (integer) 방향 내부:1, 외부: 2, 양방향: 3
  }
}
const pop3Data = {
  pop3_alert_msg: '', // (string) POP3 알림 메시지,
  pop3_excpt_mail_list_id: null, // (integer)(not null) 예외 메일 ID
  pop3_spam: {
    pop3_spam_chk_use: 0, // (integer)(not null)(Define=0,1) 스팸 검사 사용 여부 사용안함: 0, 사용: 1,
    pop3_spam_chk_direct: 3, // (integer)(not null)(Define=1,2,3) 방향 내부:1, 외부: 2, 양방향: 3,
    pop3_spam_chk_action: 1 // (integer)(not null)(Define=1,2,3) 탐지: 1, 차단: 2, 알림: 3
  },
  pop3_ban_word: {
    pop3_ban_word_chk_use: 0, // (integer) 금지 단어 검사 사용 여부 사용안함: 0, 사용: 1,
    pop3_ban_word_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    pop3_ban_word_chk_action: 1, // (integer) 탐지: 1, 차단: 2, 알림: 3,
    pop3_ban_word_list_id: null // (integer) 금지명령어 ID
  },
  pop3_block_mail: {
    pop3_block_mail_chk_use: 0, // (integer) 차단 메일 주소 사용 여부 사용안함: 0, 사용: 1,
    pop3_block_mail_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    pop3_block_mail_chk_action: 1, // (integer) 탐지: 1, 차단: 2, 알림: 3,
    pop3_block_mail_list_id: null // (integer) 차단 메일 ID
  },
  pop3_blank_title: {
    pop3_blank_title_chk_use: 0, // (integer) 빈 제목 검사 사용 여부 사용안함: 0, 사용: 1,
    pop3_blank_title_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    pop3_blank_title_chk_action: 1 // (integer) 탐지: 1, 차단: 2, 알림: 3
  },
  pop3_sndr_addr: {
    pop3_sndr_addr_chk_use: 0, // (integer) 송신자 주소 유효성 검사 사용 여부 사용안함: 0, 사용: 1,
    pop3_sndr_addr_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    pop3_sndr_addr_chk_action: 1 // (integer) 탐지: 1, 차단: 2, 알림: 3
  },
  pop3_mail_cntnt_save: {
    pop3_mail_cntnt_save_use: 0, // (integer) 메일 본문 저장 사용 여부 사용안함: 0, 사용: 1,
    pop3_mail_cntnt_save_direct: 3 // (integer) 방향 내부:1, 외부: 2, 양방향: 3
  }
}
const imapData = {
  imap_alert_msg: '', // (string) IMAP 알림 메시지,
  imap_excpt_mail_list_id: null, // (integer)(not null) 예외 메일 ID
  imap_spam: {
    imap_spam_chk_use: 0, // (integer)(not null)(Define=0,1) 사용 여부 사용안함: 0, 사용: 1,
    imap_spam_chk_direct: 3, // (integer)(not null)(Define=1,2,3) 방향 내부:1, 외부: 2, 양방향: 3,
    imap_spam_chk_action: 1 // (integer)(not null)(Define=1,2,3) 탐지: 1, 차단: 2, 알림: 3
  },
  imap_ban_word: {
    imap_ban_word_chk_use: 0, // (integer) 금지 단어 검사 사용 여부 사용안함: 0, 사용: 1,
    imap_ban_word_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    imap_ban_word_chk_action: 1, // (integer) 탐지: 1, 차단: 2, 알림: 3,
    imap_ban_word_list_id: null // (integer) 금지명령어 ID
  },
  imap_block_mail: {
    imap_block_mail_chk_use: 0, // (integer) 차단 메일 주소 사용 여부 사용안함: 0, 사용: 1,
    imap_block_mail_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    imap_block_mail_chk_action: 1, // (integer) 탐지: 1, 차단: 2, 알림: 3,
    imap_block_mail_list_id: null // (integer) 차단 메일 ID
  },
  imap_blank_title: {
    imap_blank_title_chk_use: 0, // (integer) 빈 제목 검사 사용 여부 사용안함: 0, 사용: 1,
    imap_blank_title_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    imap_blank_title_chk_action: 1 // (integer) 탐지: 1, 차단: 2, 알림: 3
  },
  imap_sndr_addr: {
    imap_sndr_addr_chk_use: 0, // (integer) 송신자 주소 유효성 검사 사용 여부 사용안함: 0, 사용: 1,
    imap_sndr_addr_chk_direct: 3, // (integer) 방향 내부:1, 외부: 2, 양방향: 3,
    imap_sndr_addr_chk_action: 1 // (integer) 탐지: 1, 차단: 2, 알림: 3
  },
  imap_mail_cntnt_save: {
    imap_mail_cntnt_save_use: 0, // (integer) 메일 본문 저장 사용 여부 사용안함: 0, 사용: 1,
    imap_mail_cntnt_save_direct: 3 // (integer) 방향 내부:1, 외부: 2, 양방향: 3
  }
}
const dataForm = () => {
  return {
    as_prf_id: null,
    as_prf_uname: '', // (string)(not null)(range=1-32) 프로파일 이름,
    as_prf_desc: '', // (string)(not null)(range=0-128) 프로파일 설명,
    smtp: smtpData,
    pop3: pop3Data,
    imap: imapData
  }
}

const modifyAntiSpamProfileDetailData = (data) => {
  const tempData = _.cloneDeep(dataForm())
  // main
  tempData.as_prf_id = data.as_prf_id
  tempData.as_prf_uname = data.as_prf_uname
  tempData.as_prf_desc = data.as_prf_desc

  _.forEach(_.keys(data.smtp), (item) => {
    if (tempData.smtp[item] !== undefined) {
      const exceptKey = _.filter(_.keys(data.smtp[item]), key => {
        return _.includes(key, '_value')
      })
      tempData.smtp[item] = _.omit(data.smtp[item], [exceptKey])
    }
  })
  _.forEach(_.keys(data.pop3), (item) => {
    if (tempData.pop3[item] !== undefined) {
      const exceptKey = _.filter(_.keys(data.pop3[item]), key => {
        return _.includes(key, '_value')
      })
      tempData.pop3[item] = _.omit(data.pop3[item], [exceptKey])
    }
  })
  _.forEach(_.keys(data.imap), (item) => {
    if (tempData.imap[item] !== undefined) {
      const exceptKey = _.filter(_.keys(data.imap[item]), key => {
        return _.includes(key, '_value')
      })
      tempData.imap[item] = _.omit(data.imap[item], [exceptKey])
    }
  })
  // smtp
  tempData.smtp.smtp_alert_msg = data.smtp.smtp_msg
  tempData.smtp.smtp_excpt_mail_list_id = (data.smtp.smtp_excpt_mail === null) ? null : data.smtp.smtp_excpt_mail.excpt_mail_list_id
  tempData.smtp.smtp_ban_word.smtp_ban_word_list_id = (data.smtp.smtp_ban_word.smtp_ban_word_chk_value === null) ? null : data.smtp.smtp_ban_word.smtp_ban_word_chk_value.ban_word_list_id
  tempData.smtp.smtp_block_mail.smtp_block_mail_list_id = (data.smtp.smtp_block_mail.smtp_block_mail_chk_value === null) ? null : data.smtp.smtp_block_mail.smtp_block_mail_chk_value.block_mail_list_id
  // 그대로 유지.
  tempData.smtp.smtp_mail_relay.smtp_mail_relay_list_id = (data.smtp.smtp_mail_relay.smtp_mail_relay_chk_value === null) ? null : data.smtp.smtp_mail_relay.smtp_mail_relay_chk_value.smtp_mail_relay_list_id
  // 그대로 유지.
  tempData.smtp.smtp_ban_cmd.smtp_ban_cmd_list_id = (data.smtp.smtp_ban_cmd.smtp_ban_cmd_chk_value === null) ? null : data.smtp.smtp_ban_cmd.smtp_ban_cmd_chk_value.smtp_ban_cmd_list_id
  tempData.smtp.smtp_ban_cmd.smtp_ban_cmd_list_id = (data.smtp.smtp_ban_cmd.smtp_ban_cmd_chk_value === null) ? null : data.smtp.smtp_ban_cmd.smtp_ban_cmd_chk_value.smtp_ban_cmd_list_id
  tempData.smtp.smtp_bomb_attack.smtp_bomb_attack_chk_value = data.smtp.smtp_bomb_attack.smtp_bomb_attack_chk_value
  // pop3
  tempData.pop3.pop3_alert_msg = data.pop3.pop3_msg
  tempData.pop3.pop3_excpt_mail_list_id = (data.pop3.pop3_excpt_mail === null) ? null : data.pop3.pop3_excpt_mail.excpt_mail_list_id
  tempData.pop3.pop3_ban_word.pop3_ban_word_list_id = (data.pop3.pop3_ban_word.pop3_ban_word_chk_value === null) ? null : data.pop3.pop3_ban_word.pop3_ban_word_chk_value.ban_word_list_id
  tempData.pop3.pop3_block_mail.pop3_block_mail_list_id = (data.pop3.pop3_block_mail.pop3_block_mail_chk_value === null) ? null : data.pop3.pop3_block_mail.pop3_block_mail_chk_value.block_mail_list_id

  // imap
  tempData.imap.imap_alert_msg = data.imap.imap_msg
  tempData.imap.imap_excpt_mail_list_id = (data.imap.imap_excpt_mail === null) ? null : data.imap.imap_excpt_mail.excpt_mail_list_id
  tempData.imap.imap_ban_word.imap_ban_word_list_id = (data.imap.imap_ban_word.imap_ban_word_chk_value === null) ? null : data.imap.imap_ban_word.imap_ban_word_chk_value.ban_word_list_id
  tempData.imap.imap_block_mail.imap_block_mail_list_id = (data.imap.imap_block_mail.imap_block_mail_chk_value === null) ? null : data.imap.imap_block_mail.imap_block_mail_chk_value.block_mail_list_id
  return tempData
}
export const state = () => ({
  txtAntiSpamProfileUrl: '/api/op/as/profiles',
  txtAntiSpamFunctionUrl: '/api/op/as/function/profiles',
  txtAntiSpamProfileCommitUrl: '/api/op/command/as-profiles',
  // 선택한 프로파일 row 데이터
  rowSelectItems: {},
  // 안티스팸 프로파일 목록 조회
  profileTitleData: [],
  // 안티스팸 예외목록
  getExcptListData: [],
  // 차단메일
  getBlockMailListData: [],
  // 금지 단어
  getForbiddenWordListData: [],
  // 보호 메일 서버
  getProtectMailListData: [],
  // SMTP 금지 명령어
  getSmtpCommandListData: [],
  // 안티스팸 프로파일 편집
  profileDetailData: dataForm(),
  originData: dataForm(),
  arrCheckBoxData: {
    // SMTP 탭
    checkedBasic: 0,
    checkedAdv: 0,
    // POP3 탭
    checkedPop3: 0,
    // IMAP 탭
    checkedImap: 0
  }
})

export const mutations = {
  clearStore: (state) => {
    state.rowSelectItems = {}
    state.profileTitleData = []
    state.getExcptListData = []
    state.getBlockMailListData = []
    state.getForbiddenWordListData = []
    state.getProtectMailListData = []
    state.getSmtpCommandListData = []
    state.profileDetailData = dataForm()
    state.originData = dataForm()
    state.arrCheckBoxData = {}
  },
  restoreData: (state) => {
    state.profileDetailData = _.cloneDeep(state.originData)
  },
  setRowSelectItems: (state, data) => {
    state.rowSelectItems = _.cloneDeep(data)
  },
  profileTitleDataAction: (state, data) => {
    state.profileTitleData = _.cloneDeep(data)
  },
  getAntiSpamOptionList: (state, data) => {
    // 안티스팸 예외목록
    state.getExcptListData.splice(0, state.getExcptListData.length)
    if (data.excpt) {
      if (data.excpt.length > 0) {
        state.getExcptListData.push({
          label: '',
          value: null
        })
      }
      for (const key of data.excpt) {
        state.getExcptListData.push({
          label: key.excpt_mail_list_uname,
          value: key.excpt_mail_list_id
        })
      }
    }
    // 차단메일
    state.getBlockMailListData.splice(0, state.getBlockMailListData.length)
    if (data.block_mail) {
      if (data.block_mail.length > 0) {
        state.getBlockMailListData.push({
          label: '',
          value: null
        })
      }
      for (const key of data.block_mail) {
        state.getBlockMailListData.push({
          label: key.block_mail_list_uname,
          value: key.block_mail_list_id
        })
      }
    }
    // 금지 단어
    state.getForbiddenWordListData.splice(0, state.getForbiddenWordListData.length)
    if (data.forbidden_word) {
      if (data.forbidden_word.length > 0) {
        state.getForbiddenWordListData.push({
          label: '',
          value: null
        })
      }
      for (const key of data.forbidden_word) {
        state.getForbiddenWordListData.push({
          label: key.ban_word_list_uname,
          value: key.ban_word_list_id
        })
      }
    }
    // 보호 메일 서버
    state.getProtectMailListData.splice(0, state.getProtectMailListData.length)
    if (data.protect_mail) {
      if (data.protect_mail.length > 0) {
        state.getProtectMailListData.push({
          label: '',
          value: null
        })
      }
      for (const key of data.protect_mail) {
        state.getProtectMailListData.push({
          label: key.smtp_mail_relay_list_uname,
          value: key.smtp_mail_relay_list_id
        })
      }
    }
    // SMTP 금지 명령어
    state.getSmtpCommandListData.splice(0, state.getSmtpCommandListData.length)
    if (data.smtp_command) {
      if (data.smtp_command.length > 0) {
        state.getSmtpCommandListData.push({
          label: '',
          value: null
        })
      }
      for (const key of data.smtp_command) {
        state.getSmtpCommandListData.push({
          label: key.smtp_ban_cmd_list_uname,
          value: key.smtp_ban_cmd_list_id
        })
      }
    }
  },
  getAntiSpamProfileDetailDataAction: (state, data) => { // 안티스팸 프로파일 상세 조회
    state.profileDetailData = _.cloneDeep(modifyAntiSpamProfileDetailData(data))
    state.originData = _.cloneDeep(modifyAntiSpamProfileDetailData(data))
  },
  addAntiSpamProfileDataAction: (state, data) => {
    state.profileTitleData.push(data)
  },
  editProfileTitle: (state, data) => {
    state.profileTitleData = _.map(state.profileTitleData, (item) => {
      if (item.as_prf_id === state.rowSelectItems[0].as_prf_id) {
        item.as_prf_uname = _.cloneDeep(data.as_prf_uname)
        item.as_prf_desc = _.cloneDeep(data.as_prf_desc)
      }
      return item
    })
  },
  editAntiSpamProfileDataAction: (state, data) => {
    // 자동으로 셀렉트 해서 재조회 함. ornginData 만 변경.
    state.originData = _.cloneDeep(modifyAntiSpamProfileDetailData(data))
  }
}

export const actions = {
  // 안티스팸 프로파일 조회
  async profileTitleDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtAntiSpamProfileUrl)
      return resultFactory(commit, {length: null, data: data, action: 'profileTitleDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 안티스팸 Select Option 목록데이터 조회
  async getAntiSpamOptionList ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtAntiSpamFunctionUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getAntiSpamOptionList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 안티스팸 프로파일 상세 조회
  async getAntiSpamProfileDetailDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.txtAntiSpamProfileUrl}/${state.rowSelectItems[0].as_prf_id}`)
      return resultFactory(commit, {length: null, data: data, action: 'getAntiSpamProfileDetailDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 안티스팸 프로파일 추가
  async addAntiSpamProfileDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(state.txtAntiSpamProfileUrl, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addAntiSpamProfileDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 안티스팸 프로파일 Title 수정
  async editProfileTitle ({commit, state}) {
    try {
      const data = await this.$axios.$put(`${state.txtAntiSpamProfileUrl}/${state.rowSelectItems[0].as_prf_id}`, state.profileDetailData, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'editProfileTitle', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 안티스팸 프로파일 상세정보 수정
  async editAntiSpamProfileDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtAntiSpamProfileUrl}/${payload}`, state.profileDetailData, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'editAntiSpamProfileDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 안티스팸 프로파일 삭제
  async delAntiSpamProfileDataAction  ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.rowSelectItems.length > 1) {
      isMulty = true
      state.rowSelectItems.forEach((item) => {
        idList.push({'as_prf_id': item.as_prf_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(state.txtAntiSpamProfileUrl, {data: {items: idList}}, {failAlert: false}) : await this.$axios.$delete(`${state.txtAntiSpamProfileUrl}/${state.rowSelectItems[0].as_prf_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 안티스팸 프로파일 적용/취소
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.txtAntiSpamProfileCommitUrl}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return false
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}

export const getters = {
  compareEditData (state) {
    try {
      return compareObject(state.originData, state.profileDetailData)
    } catch (e) {
      return false
    }
  }
}
